import React from "react";

const OrderPurchaseIcon = () => {
  return (
<svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 1H3C1.89543 1 1 1.73741 1 2.64706V13.3529C1 14.2626 1.89543 15 3 15H13C14.1046 15 15 14.2626 15 13.3529V2.64706C15 1.73741 14.1046 1 13 1Z" stroke="white"/>
<path d="M5.00049 5.11719H11.0005M5.00049 8.4113H11.0005M5.00049 11.7054H9.00049" stroke="white" stroke-linecap="round"/>
</svg>




  );
};

export default OrderPurchaseIcon;